const config = {
  meta: {
    title: 'Double Shift.',
    social: {
      fb: null,
      twitter: null,
    },
    email: 'hello@client.com',
  },
  i18n: {
    locales: ['nl', 'en'],
    defaultLocale: 'en',
  },
  sites: [
    {
      locale: 'en',
      handle: 'doubleShiftEn',
    },
    {
      locale: 'nl',
      handle: 'doubleShiftNl',
    },
  ],
  pages: [
    {
      name: 'home',
      options: null,
    },
  ],
  environments: {
    default: {
      siteUrl: 'http://localhost:8080',
      hosts: {
        fe: 'http://localhost:8080',
        be: 'http://localhost:8080',
      },
      gtm: null,
      gtagId: null,
      facebookAppId: null,
      tracedock: null,
      seoAllowIndexing: false,
    },
    accept: {
      siteUrl: 'https://accept.double-shift.com/',
      hosts: {
        fe: 'https://accept-admin.double-shift.com',
        be: 'https://accept-admin.double-shift.com',
      },
    },
    production: {
      siteUrl: 'https://www.double-shift.com',
      hosts: {
        fe: 'https://admin.double-shift.com',
        be: 'https://admin.double-shift.com',
      },
      seoAllowIndexing: true,
      gtm: 'GTM-NWW5NRD',
      gtagId: 'AW-10990562936',
      cookieBotId: 'b1df4879-4113-4e90-b267-030fca8022b5',
      tracedock: true,
    },
  },
  beforeFilesRewrites: [],
  afterFilesRewrites: [],
};

module.exports = config;
